import styled, { css, keyframes } from 'styled-components';
import PlayButton from '../../ui-components/PlayButton/PlayButton';
import { playFocus } from '../../ui-components/utils.styles';
import { playFontIcon } from '../../ui-components/typography/helpers';
import { iconHeartFilled, iconHeart } from '../../ui-components/design-tokens';

const bounce = keyframes`
    0% {
        transform: scale(1)
    }

    80% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
`;

const rebounce = keyframes`
    0% {
        transform: scale(1);
        content: '${iconHeartFilled}';
    }

    20% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
        content: '${iconHeart}';
    }
`;

export const StyledFavoriteButton = styled(PlayButton)`
    display: flex;
    align-items: center;
    align-self: flex-start;
    margin-top: 25px;
    ${playFocus()}

    &:focus {
        outline: none;
    }

    ${({ isHidden }) => {
        return (
            isHidden &&
            css`
                visibility: hidden;
            `
        );
    }};

    ${({ triggerAnimation }) => {
        return (
            triggerAnimation &&
            css`
                &:before {
                    animation-duration: 300ms;
                }
            `
        );
    }};

    ${({ isFavorite }) => {
        return isFavorite
            ? css`
                  &:before {
                      animation-name: ${bounce};
                      margin-right: 10px;
                      ${playFontIcon(1.9, iconHeartFilled)}
                  }
              `
            : css`
                  &:before {
                      animation-name: ${rebounce};
                      margin-right: 10px;
                      ${playFontIcon(1.9, iconHeart)}
                  }
              `;
    }}
`;
